<template>
  <div class="home">
    <MainBanner />
    <NextAuction />
    <UpcomingAuctions></UpcomingAuctions>
    <!-- Artistas -->
    <ArtistsCarrousel :artists="artistsData" />
  </div>
</template>
<script>
import MainBanner from '@/components/MainBanner/MainBanner.vue';
import NextAuction from '@/components/NextAuction/NextAuction.vue';
import UpcomingAuctions from '@/components/UpcomingAuctions/UpcomingAuctions.vue';
import ArtistsCarrousel from '@/components/ArtistsCarrousel/ArtistsCarrousel.vue';
import RegisterMixin from '@/mixins/RegisterMixin';

export default {
  name: 'Home',
  components: {
    ArtistsCarrousel,
    MainBanner,
    NextAuction,
    UpcomingAuctions,
  },
  mixins: [RegisterMixin],
  data() {
    return {
      artistsData: [
        {
          name: 'ANA HOLCK',
          img: require('../../assets/artists-carrousel-1.png'),
          goToIndex: 1,
        },
        {
          name: 'ANDRÉ PENTEADO',
          img: require('../../assets/artists-carrousel-2.png'),
          goToIndex: 1,
        },
        {
          name: 'ANDRÉ FELICIANO',
          img: require('../../assets/artists-carrousel-3.png'),
          goToIndex: 1,
        },
        {
          name: 'CAMILA SOATO',
          img: require('../../assets/artists-carrousel-4.png'),
          goToIndex: 1,
        },
        {
          name: 'CAMILLE KACHANI',
          img: require('../../assets/artists-carrousel-5.png'),
          goToIndex: 1,
        },
        {
          name: 'CAROLINA PONTE',
          img: require('../../assets/artists-carrousel-6.png'),
          goToIndex: 1,
        },
        {
          name: 'CAMILLE KACHANI',
          img: require('../../assets/artists-carrousel-5.png'),
          goToIndex: 1,
        },
        {
          name: 'CAROLINA PONTE',
          img: require('../../assets/artists-carrousel-6.png'),
          goToIndex: 1,
        },
      ],
    };
  },
};
</script>
<style lang="scss">
@import '@/static/css/Variables.scss';
</style>
